"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = ['M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM11.4135 16.2678L6.2265 10.9388C5.9245 10.6288 5.9245 10.1268 6.2265 9.81675C6.5275 9.50675 7.0165 9.50675 7.31851 9.81675L11.9595 14.5848L16.6825 9.73175C16.9835 9.42275 17.4725 9.42275 17.7745 9.73175C18.0756 10.0418 18.0756 10.5438 17.7745 10.8538L12.5055 16.2678C12.3605 16.4158 12.1645 16.4998 11.9595 16.4998C11.7545 16.4998 11.5585 16.4158 11.4135 16.2678Z'];